import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { rule, validate } from 'instructure-validations';
import { presenceMessage } from '../util/validationHelpers';
import t from '@instructure/quiz-i18n/es/format-message';
var InteractionType = /*#__PURE__*/function () {
  function InteractionType(obj) {
    _classCallCheck(this, InteractionType);
    _defineProperty(this, "defaultProperties", {});
    _defineProperty(this, "getDefaultInteractionData", function () {
      return {};
    });
    _defineProperty(this, "getDefaultScoringData", function () {
      return {};
    });
    _defineProperty(this, "getReadableResponseText", function () {});
    _defineProperty(this, "hideResultStem", false);
    _defineProperty(this, "id", 0);
    _defineProperty(this, "itemBody", null);
    _defineProperty(this, "translatedName", null);
    _defineProperty(this, "rawName", null);
    _defineProperty(this, "scoringAlgorithmDefault", null);
    _defineProperty(this, "scoringAlgorithmOptions", []);
    _defineProperty(this, "slug", 'choice');
    _defineProperty(this, "userResponseTypeOptions", []);
    _defineProperty(this, "isSubjective", false);
    if (obj !== void 0) {
      this.initializeProps(obj);
    }
  }
  return _createClass(InteractionType, [{
    key: "initializeProps",
    value: function initializeProps(obj) {
      var jsObj = obj;
      // May be constructed from an immutable.js map
      if (obj && typeof obj.toJS === 'function') {
        jsObj = obj.toJS();
      }
      Object.assign(this, jsObj);
    }
  }, {
    key: "hasResponse",
    value: function hasResponse(resp) {
      // NOTE: resp is userResponse.value
      // This function is to determine whether the userResponse
      // actually indicates that a response was given.
      // Interaction types with more complex userResponse data
      // can override this function.
      return resp !== null && resp !== void 0 && resp !== '';
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var objectToValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      var target = objectToValidate;
      // the target is likely an immutable js objct
      if (typeof target.toJS === 'function') {
        target = objectToValidate.toJS();
      }
      return this.constructor.getErrors(target);
    }
  }, {
    key: "getDefaultUserResponse",
    value: function getDefaultUserResponse(intData) {
      return void 0;
    }
  }, {
    key: "name",
    get: function get() {
      // Prefer the localized name over static name from database
      return this.translatedName || this.rawName;
    },
    set: function set(val) {
      this.rawName = val;
    }
  }], [{
    key: "getErrors",
    value: function getErrors(objectToValidate) {
      return _objectSpread(_objectSpread({}, validate(objectToValidate, this.baseValidations)), validate(objectToValidate, this.validations));
    }
  }, {
    key: "baseValidations",
    value: function baseValidations() {
      return {
        itemBody: [rule('presence', {
          message: presenceMessage(t('Question Stem'))
        })]
      };
    }
  }, {
    key: "validations",
    value: function validations() {
      return {};
    }
  }]);
}();
export { InteractionType as default };